import App from './App.svelte';

window.initWinCalculator = function(target, props = {}){
	if(typeof target === 'string') target = document.querySelector('#' + target)
	return new App({ target, props })
}